<template>
    <v-row justify="center">
        <v-dialog v-model="show_dialog" persistent max-width="1000" scrollable>
            <v-card>
                <v-card-title class="headline title-color mb-2">
                    {{ title }}
                </v-card-title>
                <v-card-text>
                    <slot></slot>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" outlined @click="$emit('desagree')">
                        Rechazar
                    </v-btn>
                    <v-btn color="primary darken-1" @click="$emit('agree')">
                        Aceptar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
export default {
    name: "SignContract",
    props: {
        show_dialog: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true,
        }
    }
};
</script>
